import { render } from "./LayerOverlay.vue?vue&type=template&id=470c1c6a&scoped=true"
import script from "./LayerOverlay.vue?vue&type=script&lang=js"
export * from "./LayerOverlay.vue?vue&type=script&lang=js"

import "./LayerOverlay.vue?vue&type=style&index=0&id=470c1c6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470c1c6a"]])

export default __exports__